/**
 * Created on 1/16/2020.
 */

/**
 * loads data from session storage for a given key.
 * @param {string} key: key to get from session storage
 * @returns {object} the object from session storage
 */
export const loadStorage = (key) => {
	try {
		const serializedState = sessionStorage.getItem(key);
		if (serializedState === null) {
			return undefined;
		}
		return JSON.parse(serializedState);
	} catch (err) {
		return undefined;
	}
};

/**
 * loads data from session storage for a given key.
 * @param {string} key: key to add to session storage
 * @param {object} state: the state to store
 */
export const saveStorage = (key, state) => {
	try {
		const serializedState = JSON.stringify(state);
		sessionStorage.setItem(key, serializedState);
	} catch (err) {
		//ignore
	}
};
